import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as _132 from "./epochs/genesis";
import * as _133 from "./epochs/query";
import * as _134 from "./gamm/pool-models/balancer/balancerPool";
import * as _135 from "./gamm/v1beta1/genesis";
import * as _136 from "./gamm/v1beta1/query";
import * as _137 from "./gamm/v1beta1/tx";
import * as _138 from "./gamm/pool-models/balancer/tx";
import * as _139 from "./gamm/pool-models/stableswap/stableswap_pool";
import * as _140 from "./gamm/pool-models/stableswap/tx";
import * as _141 from "./incentives/gauge";
import * as _142 from "./incentives/genesis";
import * as _143 from "./incentives/params";
import * as _144 from "./incentives/query";
import * as _145 from "./incentives/tx";
import * as _146 from "./lockup/genesis";
import * as _147 from "./lockup/lock";
import * as _148 from "./lockup/query";
import * as _149 from "./lockup/tx";
import * as _150 from "./mint/v1beta1/genesis";
import * as _151 from "./mint/v1beta1/mint";
import * as _152 from "./mint/v1beta1/query";
import * as _153 from "./pool-incentives/v1beta1/genesis";
import * as _154 from "./pool-incentives/v1beta1/gov";
import * as _155 from "./pool-incentives/v1beta1/incentives";
import * as _156 from "./pool-incentives/v1beta1/query";
import * as _157 from "./store/v1beta1/tree";
import * as _158 from "./superfluid/genesis";
import * as _159 from "./superfluid/params";
import * as _160 from "./superfluid/query";
import * as _161 from "./superfluid/superfluid";
import * as _162 from "./superfluid/tx";
import * as _163 from "./tokenfactory/v1beta1/authorityMetadata";
import * as _164 from "./tokenfactory/v1beta1/genesis";
import * as _165 from "./tokenfactory/v1beta1/params";
import * as _166 from "./tokenfactory/v1beta1/query";
import * as _167 from "./tokenfactory/v1beta1/tx";
import * as _168 from "./txfees/v1beta1/feetoken";
import * as _169 from "./txfees/v1beta1/genesis";
import * as _170 from "./txfees/v1beta1/gov";
import * as _171 from "./txfees/v1beta1/query";
import * as _284 from "./gamm/pool-models/balancer/tx.amino";
import * as _285 from "./gamm/pool-models/stableswap/tx.amino";
import * as _286 from "./gamm/v1beta1/tx.amino";
import * as _287 from "./incentives/tx.amino";
import * as _288 from "./lockup/tx.amino";
import * as _289 from "./superfluid/tx.amino";
import * as _290 from "./tokenfactory/v1beta1/tx.amino";
import * as _291 from "./gamm/pool-models/balancer/tx.registry";
import * as _292 from "./gamm/pool-models/stableswap/tx.registry";
import * as _293 from "./gamm/v1beta1/tx.registry";
import * as _294 from "./incentives/tx.registry";
import * as _295 from "./lockup/tx.registry";
import * as _296 from "./superfluid/tx.registry";
import * as _297 from "./tokenfactory/v1beta1/tx.registry";
import * as _298 from "./epochs/query.lcd";
import * as _299 from "./gamm/v1beta1/query.lcd";
import * as _300 from "./incentives/query.lcd";
import * as _301 from "./lockup/query.lcd";
import * as _302 from "./mint/v1beta1/query.lcd";
import * as _303 from "./pool-incentives/v1beta1/query.lcd";
import * as _304 from "./superfluid/query.lcd";
import * as _305 from "./tokenfactory/v1beta1/query.lcd";
import * as _306 from "./txfees/v1beta1/query.lcd";
import * as _307 from "./epochs/query.rpc.query";
import * as _308 from "./gamm/v1beta1/query.rpc.query";
import * as _309 from "./incentives/query.rpc.query";
import * as _310 from "./lockup/query.rpc.query";
import * as _311 from "./mint/v1beta1/query.rpc.query";
import * as _312 from "./pool-incentives/v1beta1/query.rpc.query";
import * as _313 from "./superfluid/query.rpc.query";
import * as _314 from "./tokenfactory/v1beta1/query.rpc.query";
import * as _315 from "./txfees/v1beta1/query.rpc.query";
import * as _316 from "./gamm/pool-models/balancer/tx.rpc.msg";
import * as _317 from "./gamm/pool-models/stableswap/tx.rpc.msg";
import * as _318 from "./gamm/v1beta1/tx.rpc.msg";
import * as _319 from "./incentives/tx.rpc.msg";
import * as _320 from "./lockup/tx.rpc.msg";
import * as _321 from "./superfluid/tx.rpc.msg";
import * as _322 from "./tokenfactory/v1beta1/tx.rpc.msg";
export let osmosis;

(function (_osmosis) {
  let epochs;

  (function (_epochs) {
    const v1beta1 = _epochs.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _132), _133), _298), _307);
  })(epochs || (epochs = _osmosis.epochs || (_osmosis.epochs = {})));

  let gamm;

  (function (_gamm) {
    const v1beta1 = _gamm.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _134), _135), _136), _137), _286), _293), _299), _308), _318);

    let poolmodels;

    (function (_poolmodels) {
      let balancer;

      (function (_balancer) {
        const v1beta1 = _balancer.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _138), _284), _291), _316);
      })(balancer || (balancer = _poolmodels.balancer || (_poolmodels.balancer = {})));

      let stableswap;

      (function (_stableswap) {
        const v1beta1 = _stableswap.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _139), _140), _285), _292), _317);
      })(stableswap || (stableswap = _poolmodels.stableswap || (_poolmodels.stableswap = {})));
    })(poolmodels || (poolmodels = _gamm.poolmodels || (_gamm.poolmodels = {})));
  })(gamm || (gamm = _osmosis.gamm || (_osmosis.gamm = {})));

  const incentives = _osmosis.incentives = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _141), _142), _143), _144), _145), _287), _294), _300), _309), _319);

  const lockup = _osmosis.lockup = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _146), _147), _148), _149), _288), _295), _301), _310), _320);

  let mint;

  (function (_mint) {
    const v1beta1 = _mint.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _150), _151), _152), _302), _311);
  })(mint || (mint = _osmosis.mint || (_osmosis.mint = {})));

  let poolincentives;

  (function (_poolincentives) {
    const v1beta1 = _poolincentives.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _153), _154), _155), _156), _303), _312);
  })(poolincentives || (poolincentives = _osmosis.poolincentives || (_osmosis.poolincentives = {})));

  let store;

  (function (_store) {
    const v1beta1 = _store.v1beta1 = _objectSpread({}, _157);
  })(store || (store = _osmosis.store || (_osmosis.store = {})));

  const superfluid = _osmosis.superfluid = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _158), _159), _160), _161), _162), _289), _296), _304), _313), _321);

  let tokenfactory;

  (function (_tokenfactory) {
    const v1beta1 = _tokenfactory.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _163), _164), _165), _166), _167), _290), _297), _305), _314), _322);
  })(tokenfactory || (tokenfactory = _osmosis.tokenfactory || (_osmosis.tokenfactory = {})));

  let txfees;

  (function (_txfees) {
    const v1beta1 = _txfees.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _168), _169), _170), _171), _306), _315);
  })(txfees || (txfees = _osmosis.txfees || (_osmosis.txfees = {})));
})(osmosis || (osmosis = {}));